<template>
  <div>
    <div :class="`side-btn ${isRight && 'side-btn--reversal'}`" @click="handleOpen">
      <i class="el-icon-arrow-right"></i>
    </div>
    <transition :name="isRight ? 'slide-fade-rt' : 'slide-fade-lt'">
      <div class="side-drawer-container" v-show="visible" :style="{right: isRight ? 0 : '', ...drawerStyle}">
        <div :class="`side-close-btn ${isRight && 'side-close-btn--reversal'}`" @click="handleClose">
          <i class="el-icon-arrow-left"></i>
        </div>
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "side-drawer",
  props: {
    visible: Boolean,
    isRight: Boolean, // 右侧
    drawerStyle: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    handleOpen() {
      this.$emit("update:visible", true);
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  }
}
</script>

<style scoped lang="scss">
$side-width: 390px;

//.slide-fade-lt-enter-active,
//.slide-fade-lt-leave-active,
//.slide-fade-rt-enter-active,
//.slide-fade-rt-leave-active {
//  transition: all .3s ease
//}
//
//.slide-fade-lt-enter,
//.slide-fade-lt-leave-to {
//  transform: translateX(-$side-width);
//}
//
//.slide-fade-rt-enter,
//.slide-fade-rt-leave-to {
//  transform: translateX($side-width);
//}

.side-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 56px;
  line-height: 56px;
  font-size: 25px;
  background-color: #fff;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  z-index: 10;

  i {
    font-weight: 900;
  }

  &--reversal {
    right: 0;
    transform: scaleX(-1);
  }
}

.side-drawer-container {
  position: absolute;
  width: $side-width;
  height: calc(100% - 60px);
  top: 0;
  background-color: #fff;
  padding: 23px;
  //box-shadow: 0 8px 10px -5px rgba(0, 0, 0, .2), 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12);
  z-index: 1000;

  .side-close-btn {
    position: absolute;
    width: fit-content;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    font-size: 25px;
    cursor: pointer;

    i {
      font-weight: 900;
    }

    &--reversal {
      left: 0;
      transform: scaleX(-1);
    }
  }
}
</style>
